import { axiosInstance } from '@/plugins/axios';

export default {
	namespaced: true,
	state: {
		tasks: {},
    task: {},
    currentTask: {},
    phraseDiary: {},
    text: {},
    challenges: {},
    editModalChallenge: {},
    bonus: {},
	},
	getters: {
		tasks(state) {
			return state.tasks;
		},
    task(state) {
			return state.task;
		},
    currentTask(state){
      return state.currentTask;
    },
    phraseDiary(state){
      return state.phraseDiary;
    },
    text(state){
      return state.text;
    },
    challenges(state){
      return state.challenges;
    },
    editModalChallenge(state) {
      return state.editModalChallenge;
    },
	},
	mutations: {
		SET_TASKS(state, value) {
			state.tasks = value;
		},
    SET_TASK(state, value) {
			state.task = value;
		},
    SET_CURRENT_TASK(state, value) {
      state.currentTask = value;
    },
    SET_PHRASE_DIARY(state, value) {
      state.phraseDiary = value;
    },
    SET_TEXT(state, value) {
      state.text = value;
    },
    SET_CHALLENGES(state, value) {
      state.challenges = value;
    },
    SET_EDIT_MODAL_CHALLENGE(state, value) {
      state.editModalChallenge = value;
    }
	},
	actions: {
    async registerTask(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_plan', value.id_plan);
      formData.append('name', value.name);
      formData.append('description', value.description);

      const url = value?.id ? `tasks/${value.id}` : 'tasks';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultTasks');
        })
    },
    async consultTasks(context, value){
      let url;
      if (value?.idPlan) {
        url = `plans/${value.idPlan}/tasks`;
      } else if (value?.idTask) {
        url = `tasks/${value.idTask}`;
      } else {
        url = 'tasks';
      }

      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.idTask) {
            context.dispatch('setDataDefault', ['SET_TASK', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_TASKS', data]);
        })
    },
    async removeTask(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `tasks/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_TASKS', data]);
        })
    },
    async registerPhraseDiary(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_task', value.id_task);
      formData.append('title', value.title);
      formData.append('description', value.description);

      const url = value?.id ? `phraseDiary/${value.id}` : 'phraseDiary';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPhraseDiary', value.id_task);
        })
    },
    async consultPhraseDiary(context, value){
      const url = value ? `phraseDiary/${value}` : 'phraseDiary';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_PHRASE_DIARY', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_PHRASE_DIARY', data]);
        })
    },
    async removePhraseDiary(context, value){
      await axiosInstance({
        method: 'DELETE',
        url: `phraseDiary/${value.id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPhraseDiary', value.id_task);
        })
    },
    async registerText(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_task', value.id_task);
      formData.append('title', value.title);
      formData.append('description', value.description);

      const url = value?.id ? `text/${value.id}` : 'text';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultText', value.id_task);
        })
    },
    async consultText(context, value){
      const url = value ? `text/${value}` : 'text';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_TEXT', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_TEXT', data]);
        })
    },
    async removeText(context, value){
      await axiosInstance({
        method: 'DELETE',
        url: `text/${value.id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultText', value.id_task);
        })
    },
    async registerChallenges(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_task', value.id_task);
      formData.append('title', value.title);
      formData.append('description', value.description);

      const url = value?.id ? `challenges/${value.id}` : 'challenges';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultChallengesByIdTask', value.id_task);
        })
    },
    async registerChallengesTasks(context, value) {
      console.log('VALUE CHALLENGES TASKS', value);
      const url = value?.id_tc ? `/challenges/tasks/${value.id_tc}` : '/challenges/tasks';
      delete value?.id_tc;

      await axiosInstance({
        method: 'POST',
        url: url,
        data: value,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultChallengesByIdTask', value.id_task);
        })
    },
    async removeChallenge(context, value){
      await axiosInstance({
        method: 'DELETE',
        url: `challenges/${value.id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultChallengesByIdTask', value.id_task);
        })
    },
    async consultChallengesByIdTask(context, value){
      const url = value ? `challenges/${value}` : 'challenges';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_CHALLENGES', data]);
        })
    },
    async removeChallengeTask(context, value){
      await axiosInstance({
        method: 'DELETE',
        url: `/challenges/tasks/${value.id_tc}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultChallengesByIdTask', value.id_task);
        })
    },
    setDataDefault(context, [mutationName, value]){
      context.commit(`${mutationName}`, value);
    },
    setCurrentTask(context, value){
      context.commit('SET_CURRENT_TASK', value);
    },
    setEditModalChallenge(context, value){
      context.commit('SET_EDIT_MODAL_CHALLENGE', value);
    },
	}
}
